import { cn } from '@/utils/cls';
import { inr } from '@/utils/format';

interface MoneyProps {
  value: number | string | null | undefined;
  decimals?: boolean;
  /** Tailwind classes — caller controls size/colour */
  className?: string;
  /** Tone hints — adds a subtle colour for negative or zero balances */
  tone?: 'auto' | 'positive' | 'negative' | 'neutral';
}

/** Renders a ₹ amount with Indian comma grouping. Tabular nums so columns
 *  of money line up perfectly. */
export function Money({ value, decimals = false, className, tone = 'auto' }: MoneyProps) {
  const n = Number(value ?? 0);
  let toneClass = '';
  if (tone === 'auto') {
    if (n < 0) toneClass = 'text-danger';
  } else if (tone === 'positive') {
    toneClass = 'text-success';
  } else if (tone === 'negative') {
    toneClass = 'text-danger';
  }
  return (
    <span className={cn('tabular-nums', toneClass, className)}>
      {inr(n, { decimals })}
    </span>
  );
}
